import MUIChip from '@mui/material/Chip';

export const Chip = (props: Readonly<React.ComponentProps<typeof MUIChip>>) => (
  <MUIChip {...props} />
);
